module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "jobs"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "jobs__content"
  }, [_c('div', {
    staticClass: "jobs__image",
    style: ({
      'background-image': 'url( ' + _vm.post.better_featured_image.source_url + ' )'
    })
  }, [_c('span', {
    staticClass: "jobs__title",
    domProps: {
      "innerHTML": _vm._s(_vm.post.acf.job_title)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "jobs__position",
    domProps: {
      "innerHTML": _vm._s(_vm.post.acf.position)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "jobs__city",
    domProps: {
      "innerHTML": _vm._s(_vm.post.acf.city)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "jobs__description",
    domProps: {
      "innerHTML": _vm._s(_vm.post.acf.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jobs__grey-box",
    domProps: {
      "innerHTML": _vm._s(_vm.post.acf.grey_box)
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f11efa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Jobs.vue
// module id = 331
// module chunks = 0